import React from 'react';

export const PersonIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="url(#paint0_linear_8665_23696)"
      />
      <path
        d="M20 22C23.866 22 27 18.866 27 15C27 11.134 23.866 8 20 8C16.134 8 13 11.134 13 15C13 18.866 16.134 22 20 22Z"
        fill="white"
      />
      <path
        d="M10 33C10 26.925 14.477 22 20 22C25.523 22 30 26.925 30 33"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8665_23696"
          x1="0"
          y1="0"
          x2="4000"
          y2="4000"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4B6CB7" />
          <stop offset="1" stopColor="#182848" />
        </linearGradient>
      </defs>
    </svg>
  );
};
